import { Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon, ScaleIcon } from '@heroicons/react/24/outline';
import useSubstratePanelStore from '@/stores/substratePanelStore';
import { ROUTES } from '@/utils/constants';

export default function PoliciesPanel() {
  const closePanel = useSubstratePanelStore((state) => state.closePanel);

  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
          <ScaleIcon className="w-5 h-5" />
        </div>
        <p className="text-sm text-base-content/80 leading-relaxed">
          Publish school policies, manage governing-body approval and track parent and staff signing.
        </p>
      </div>

      <Link
        to={ROUTES.POLICIES_ADMIN}
        onClick={closePanel}
        className="btn btn-primary btn-sm gap-2 self-start"
      >
        <ArrowTopRightOnSquareIcon className="w-4 h-4" />
        Open Policies
      </Link>
    </div>
  );
}
